var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgP5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FFFAE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4326 25.7497C27.3887 25.8258 27.3256 25.8889 27.2496 25.9328C27.1735 25.9767 27.0873 25.9998 26.9995 25.9997H14.9995C14.9118 25.9997 14.8256 25.9765 14.7497 25.9326C14.6737 25.8886 14.6107 25.8255 14.5669 25.7495C14.523 25.6735 14.5 25.5873 14.5 25.4996C14.5 25.4119 14.5231 25.3257 14.567 25.2497C15.5189 23.6041 16.9857 22.4241 18.6976 21.8647C17.8508 21.3607 17.193 20.5925 16.825 19.6784C16.457 18.7642 16.3993 17.7545 16.6607 16.8043C16.9221 15.8542 17.4882 15.0161 18.272 14.4188C19.0558 13.8215 20.014 13.498 20.9995 13.498C21.9849 13.498 22.9432 13.8215 23.727 14.4188C24.5108 15.0161 25.0769 15.8542 25.3383 16.8043C25.5997 17.7545 25.542 18.7642 25.174 19.6784C24.806 20.5925 24.1481 21.3607 23.3014 21.8647C25.0132 22.4241 26.4801 23.6041 27.432 25.2497C27.476 25.3257 27.4992 25.4119 27.4993 25.4997C27.4994 25.5874 27.4764 25.6737 27.4326 25.7497Z",
    fill: "#FFCC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP5);
export default __webpack_public_path__ + "static/media/p5.0816f85721f650e62ec888b624daba62.svg";
export { ForwardRef as ReactComponent };